import { Grid, Typography } from "@mui/material"
import {useFormContext} from "react-hook-form";
import {AsyncSelect, ControlledDatePicker, ControlledTextField} from "src/components/forms"
import {Fragment, useCallback, useEffect, useState} from "react";
import {
    AfipResponsabilityType,
    AfipResponsabilityTypeFields,
    Client,
    ClientFields,
    ClientType
} from "src/types/client/clientData";
import {SolicitationFields} from "../../../../../types/solicitation/solicitationData";
import React from "react";
import {HttpCacheClient} from "../../../../../http/cache/client/httpCacheClient";

interface InfoExtraProps {
    client: Client,
    solicitationId?: number
}

const InfoExtra = ({client, solicitationId}: InfoExtraProps) => {
    const isPhysicalPerson = client[ClientFields.ClientTypeCode] === ClientType.Fisica
    const { control, setValue, watch } = useFormContext()
    const [responsabilities, setResponsabilities] = useState<AfipResponsabilityType[]>()
    const [monotaxFields, setMonotaxFields] = useState<boolean>(false)

    useEffect(() => {
        if(client){
            setValue(ClientFields.CommercialName, client[ClientFields.CommercialName])
            setValue(ClientFields.Website, client[ClientFields.Website])
            setValue(ClientFields.AfipResponsibilityTypeCode, client[ClientFields.AfipResponsibilityTypeCode])
            setValue(ClientFields.BirthDate, isPhysicalPerson ? new Date(client[ClientFields.BirthDate]) : undefined)
            if (!isPhysicalPerson) 
                setValue(ClientFields.ClientClassificationCode, client[ClientFields.ClientClassificationCode])
        }
    }, [client, solicitationId])


    const loadClientClassifications = useCallback(() => {
        return HttpCacheClient.getClienteClasificaciones()
    }, [])

    const loadAfipResponsiblityTypes = useCallback(() => {
        return HttpCacheClient.getResponsableTipo()
    }, [])
    
    const watchAfipResponsability = watch(ClientFields.AfipResponsibilityTypeCode)

    useEffect(() => {
        HttpCacheClient.getResponsableTipo().then(setResponsabilities)
    }, []);

    useEffect(() => {
        if (responsabilities) {
            const found = responsabilities.find((i) => i.id == watchAfipResponsability)
            found && setMonotaxFields(found[AfipResponsabilityTypeFields.Monotax] ?? false)
        }
    }, [watchAfipResponsability, responsabilities]);
    
    return (
        <Fragment>
            <Grid item xs={12}>
                <Typography fontSize={16} fontWeight={550}>
                    {!isPhysicalPerson ? 'Por favor, ingrese la siguiente información sobre la empresa' : 'Por favor, ingrese la siguiente información sobre la persona'}
                </Typography>
            </Grid>
            <Grid item xs={12} container spacing={4} alignItems={'center'} mt={1}>
                <Grid item xs={3}>
                    <ControlledTextField
                        name={ClientFields.CommercialName}
                        label='Nombre Comercial'
                        control={control}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={3}>
                    <ControlledTextField
                        name={ClientFields.Website}
                        label='Sitio Web'
                        control={control}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={3}>
                    <ControlledTextField
                        name={SolicitationFields.Mail}
                        label='Mail de contacto'
                        control={control}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={3}>
                    {
                        isPhysicalPerson ?
                            <ControlledDatePicker control={control}
                                                  name={ClientFields.BirthDate}
                                                  label='Fecha de nacimiento'
                                                  sx={{width: '100% !important'}}
                            />
                            :
                            <AsyncSelect loadOptions={loadClientClassifications}
                                         control={control}
                                         name={ClientFields.ClientClassificationCode}
                                         label={'Clasificación'}
                                         fullWidth
                            />
                    }
                </Grid>
            </Grid>
            <Grid item xs={12} container spacing={4} alignItems={'center'} mt={1}>
                <Grid item xs={3}>
                    <AsyncSelect name={ClientFields.AfipResponsibilityTypeCode} 
                                 label='Responsabilidad AFIP' 
                                 control={control} 
                                 fullWidth
                                 loadOptions={loadAfipResponsiblityTypes}
                    />
                </Grid>
                <Grid item xs={1.5}>
                </Grid>
                <Grid item xs={3}>
                    {
                        isPhysicalPerson && monotaxFields &&
                        <ControlledTextField
                            name={SolicitationFields.IncomeCertifications}
                            label='Certificación de Ingresos'
                            control={control}
                            fullWidth
                            currency
                            helperText={'El ingreso real declarado del cliente con certificación del contador'}
                        />
                    }
                </Grid>
                <Grid item xs={1.5}>
                </Grid>
                <Grid item xs={3}>
                    {
                        isPhysicalPerson && monotaxFields &&
                        <ControlledTextField
                            name={SolicitationFields.MonotaxCategory}
                            label='Categoría de Monotributo'
                            control={control}
                            fullWidth
                            currency
                            helperText={'El tope de la categoría en la que esta inscripto el cliente'}
                        />
                    }
                </Grid>
            </Grid>
        </Fragment>
    )
}

export default InfoExtra